import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';
import { defaultMST4040_R01Dto, MST4040_R01Dto } from './Dto_MST4040_R01';

export interface MST4040_R01Filter {
	moldCd: string;
	moldNm: string;
	moldClass: string;
}

export interface Store_MST4040_R01 {
	MST4040_R01Filter: MST4040_R01Filter;
	MST4040_R01PastFilter: MST4040_R01Filter;
	setMST4040_R01Filter: (filter: Partial<MST4040_R01Filter>) => void;
	setMST4040_R01PastFilter: (filter: Partial<MST4040_R01Filter>) => void;

	MST4040_R01List: MST4040_R01Dto[];
	setMST4040_R01List: (MST4040_R01List: MST4040_R01Dto[]) => void;
	removeMST4040_R01: (moldCd: string) => void;

	selectedMST4040_R01: MST4040_R01Dto | undefined;
	setSelectedMST4040_R01: (MST4040_R01: MST4040_R01Dto | undefined) => void;
	initSelectedMST4040_R01: () => void;

	editMST4040_R01: MST4040_R01Dto;
	setEditMST4040_R01: (MST4040_R01: MST4040_R01Dto) => void;
	initEditMST4040_R01: () => void;

	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;
	setAllCount: (allCount: number) => void;

	initData: () => void;
}

export const defaultMST4040_R01Filter: MST4040_R01Filter = {
	moldCd: '',
	moldNm: '',
	moldClass: '',
};

export const useMST4040_R01Store = create<Store_MST4040_R01>((set) => ({
	MST4040_R01Filter: defaultMST4040_R01Filter,
	MST4040_R01PastFilter: defaultMST4040_R01Filter,
	setMST4040_R01Filter: (filter: Partial<MST4040_R01Filter>) => set((state) => ({
		MST4040_R01Filter: {
			...state.MST4040_R01Filter,
			...filter,
		},
	})),
	setMST4040_R01PastFilter: (filter: Partial<MST4040_R01Filter>) => set((state) => ({
		MST4040_R01PastFilter: {
			...state.MST4040_R01PastFilter,
			...filter,
		},
	})),

	MST4040_R01List: [],
	setMST4040_R01List: (MST4040_R01List: MST4040_R01Dto[]) => set((state) => ({
		...state,
		MST4040_R01List,
	})),
	removeMST4040_R01: (moldCd: string) => set((state) => ({
		...state,
		MST4040_R01List: [...state.MST4040_R01List].filter((value) => value.moldCd !== moldCd),
	})),

	selectedMST4040_R01: undefined,
	setSelectedMST4040_R01: (MST4040_R01: MST4040_R01Dto | undefined) => set((state) => ({
		...state,
		selectedMST4040_R01: MST4040_R01,
	})),
	initSelectedMST4040_R01: () => set({
		selectedMST4040_R01: undefined,
		editMST4040_R01: defaultMST4040_R01Dto,
	}),

	editMST4040_R01: defaultMST4040_R01Dto,
	setEditMST4040_R01: (MST4040_R01: MST4040_R01Dto) => set((state) => ({
		...state,
		editMST4040_R01: MST4040_R01,
	})),
	initEditMST4040_R01: () => set((state) => ({
		...state,
		editMST4040_R01: defaultMST4040_R01Dto,
	})),

	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	allCount: 0,
	setAllCount: (allCount: number) => set({ allCount }),

	initData: () => set((state) => ({
		...state,
		MST4040_R01Filter: defaultMST4040_R01Filter,
		MST4040_R01PastFilter: defaultMST4040_R01Filter,
		columnState: null,
		selectedMST4040_R01: undefined,
		editMST4040_R01: defaultMST4040_R01Dto,
		MST4040_R01List: [],
		allCount: 0,
		scrollTop: null,
	})),
}));
